import PropTypes from "prop-types";
import React from "react";

import { Text, textPropTypes } from "@swa-ui/core";
import i18n from "@swa-ui/locale";
import { classNames } from "@swa-ui/string";

import styles from "./FlightNumber.module.scss";

/**
 * FlightNumber displays the flight number next to the hashtag symbol.
 */
export const FlightNumber = (props) => {
  const { airlineCode, className, flightNumber, showHashtag = true, textProps } = props;

  return (
    <Text {...getProps()}>
      {renderHashTag()}
      {airlineCode}
      {flightNumber}
    </Text>
  );

  function renderHashTag() {
    return showHashtag ? (
      <Text element="span" {...textProps}>
        #
      </Text>
    ) : null;
  }

  function getProps() {
    return {
      ["aria-label"]: getFlightNumberAriaLabel(),
      className: classNames(className, styles.flightNumber),
      element: "span",
      ...textProps,
    };
  }

  function getFlightNumberAriaLabel() {
    return i18n("FlightNumber__FLIGHT_INFORMATION_ARIA_LABEL", {
      AIRLINE_CODE: airlineCode,
      FLIGHT_NUMBER: flightNumber,
    });
  }
};

FlightNumber.propTypes = {
  /** Airline code that will be rendered. */
  airlineCode: PropTypes.string,

  /** Additional class to be added to the outermost element for positioning the component. */
  className: PropTypes.string,

  /** Content that will be rendered inside the component. */
  flightNumber: PropTypes.string.isRequired,

  /** Boolean value to show or hide the hashtag symbol. */
  showHashtag: PropTypes.bool,

  /** Props passed to the underlying Text component. See Text for more details. */
  textProps: PropTypes.shape(textPropTypes),
};
